import { Database } from '@/lib/supabase/supabase_types';
import { supabase } from '@/lib/supabase/supabaseClient';
import * as queries from '@supabase/queries';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useGetProjectsWithoutCrm({organizationId}: {organizationId: string}){
    return useQuery({
        queryKey: ["projects_list_empty_crm", organizationId],
        queryFn: async () => {
            const res =  await queries.projectsListByOrgIdWithoutCrm(organizationId);
            if(res.error){
                throw new Error(res.error.message);
            }
            return res.data;
        },
        enabled: !!organizationId,
    });
}

export function useInviteUserToProject() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["inviteUserToProject"],
        mutationFn: async ({
            projectId,
            email
        }: {
            projectId: string,
            email: string
        }) => {
            const res = await queries.inviteUserToProject(projectId, email);
            if(res.error) throw new Error(res.error.message);
            if(res.data.error) throw new Error(res.data.error);
            return res;
        },
        onSuccess: (_data, variables)=> {
            queryClient.invalidateQueries({queryKey: ["projects_list"]});
            queryClient.invalidateQueries({queryKey: ["project_members", variables.projectId]});
        }
    });
}

export function useEditMultipleProjectsWithDifferentData() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["edit_projects"],
        mutationFn: async ({data}: {data: (Database['public']['Tables']['project']['Update'][])}) => {
            const res = await queries.editMultipleProjectsWithDifferentData({data});
            return res;
        },
        onSuccess: ()=> {
            queryClient.invalidateQueries({queryKey: ["projects_list"]});
            queryClient.invalidateQueries({queryKey: ["projects_list_empty_crm"]});
            queryClient.invalidateQueries({queryKey: ["crm_projects"]});
        }
    });
}

export function useGetProjectMembers(project_id: string | undefined) {
    return useQuery({
        queryKey: ["project_members", project_id],
        queryFn: async () => {
            if(!project_id) return null;
            return await queries.getProjectMembers(project_id);
        },
        enabled: !!project_id,
    });
}
